import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

interface CreateTicketInput {
  ticketType?: string;
  machineId?: string;
  ticketSourceId?: string;
  reportedAt?: string;
  assignToId: string;
  priority: string;
  serviceType?: string;
  comment?: string;
  chatDescription?: string;
  machineServices: string[];
  marketingMaterials: string[];
  marketingOrOthers: string[];
  operations: string[];
  howTicketClosed?: string | null;
  closingDateAndTime?: string;
  isClosed: boolean;
  timeSpentOnTask?: number;
  travelTime?: number;
  customerSatisfaction?: string | null;
  cleanliness?: string | null;
  trafficRate?: string | null;
  staffEnthusiasm?: string | null;

  media?: string[];
  machineServiceOtherInput: string;
  operationOtherInput: string;
  marketingOtherInput: string;
  issueReportedOtherInput: string;
  issuesReported: string[];
}
export async function createTicket(input: CreateTicketInput) {
  let data;
  data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
        mutation createTicket (
          $input: CreateTicketInput!
        ){
          createTicket(
            createTicketInput: $input
            )
        }
        `,
      variables: {
        input,
      },
    },
  }).catch((e: any) => (data = e.response));

  return data;
}

export async function getTickets(
  where: {} = {},
  paginate: any = undefined,
  customFilter: [] = []
) {
  const data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `query getTickets(
        $where: TicketResolver_GetTickets_FilterInputType, 
        $paginate: PaginatorArgs,
        $customFilter:TicketCustomFilterType!
             ) {
            getTickets(where: $where, paginate: $paginate,customFilter:$customFilter) {
                data {
                  id
                  uuid
                  ticketType
                  machineId
                  parentId
                  chatDescription
                  ticketSourceId
                  issueReportedOtherInput
                  machineServiceOtherInput
                  operationOtherInput
                  marketingOtherInput
                  scheduleStartDate
                  scheduleEndDate
                  travelingStartTime
                  travelingEndTime
                  workStartTime
                  isFilterReplaced 
                  isSanitizerReplaced
                  location{
                        id
                        name
                        customer{
                            isVip
                        }
                      }
                  media{
                    url
                    type
                  }
                  signatureName
                  signatureImage {
                    url
                    type
                  }
                  reportedAt
                  assignToId
                  priority
                  issueType {
                    id
                    name
                  }
                  diagnosisDone {
                    id
                    name
                  }
                  diagnosisOtherInput
                  reportedByType
                  reportedById
                  reportedByName
                  reportedByPhone
                  reportedByEmail
                  reportedByUser {
                    firstName
                    lastName
                  }
                  serviceType
                  issuesReported {
                    id
                    name
                  }
                  machineServices {
                    id
                    name
                  }
                  machineServicesDone {
                    id
                    name
                  }
                  operationsDone {
                    id
                    name
                  }
                  operations {
                    id
                    name
                  }
                  marketingOrOthers {
                    id
                    name
                  }
                  marketingMaterials {
                    id
                    name
                  }
                  comment
                  lastStatusComment
                  lastAssigneToComment
                  status
                  howTicketClosed
                  closingDateAndTime
                  timeSpentOnTask
                  travelTime
                  customerSatisfaction
                  cleanliness
                  trafficRate
                  staffEnthusiasm
                  createdById
                  createdAt
                  updatedById
                  updatedAt
                  machine {
                    id
                    serialNumber
                    name
                    deploymentDate
                    locationId
                    deployingPersonId
                    softwareVersion
                    hardwareVersion
                    createdById
                    updatedById
                    isActive
                    location{
                      name
                      servicePlan{
                        id
                        indicater
                      }
                    }
                  }
                  ticketSource {
                    id
                    name
                    createdAt
                    updatedAt
                  }
                  assignTo {
                    id
                    firstName
                    lastName
                  }
                  createdBy {
                    id
                    firstName
                    lastName
                  }
                  subTasks {
                    id
                    uuid
                    ticketType
                    machineId
                    parentId 
                    issueReportedOtherInput
                    machineServiceOtherInput
                    operationOtherInput
                    marketingOtherInput
                    ticketSourceId
                    media{
                      url
                      type
                    }
                    reportedAt
                    assignToId
                    priority
                    issueType {
                      id
                      name
                    }
                    machineServices {
                      id
                      name
                    }
                    operations {
                      id
                      name
                    }
                    machineServicesDone {
                      id
                      name
                    }
                    operationsDone {
                      id
                      name
                    }
                    marketingOrOthers {
                      id
                      name
                    }
                    comment
                    lastStatusComment
                    lastAssigneToComment
                    status
                    howTicketClosed
                    closingDateAndTime
                    timeSpentOnTask
                    travelTime
                    customerSatisfaction
                    cleanliness
                    trafficRate
                    staffEnthusiasm
                    createdById
                    createdAt
                    updatedById
                    updatedAt
                    machine {
                      id
                      serialNumber
                      name
                    }
                    ticketSource {
                      id
                      name
                      createdAt
                      updatedAt
                    }
                    assignTo {
                      id
                      firstName
                      lastName
                    }
                    createdBy {
                      id
                      firstName
                      lastName
                    }
                  }
                }
                totalPages 
                total
                perPage
                page 
          }
      }`,
      variables: { where, paginate, customFilter },
    },
  });
  return data?.data?.data?.getTickets;
}
export async function getTicket(id: string) {
  const data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
            query($id: String!) {
                getTicket(id: $id) {
                  id
                  uuid
                  ticketType
                  machineId
                  parentId
                  ticketSourceId
                  issueReportedOtherInput
                  machineServiceOtherInput
                  operationOtherInput
                  marketingOtherInput
                  travelingStartTime
                  travelingEndTime
                  workStartTime
                  reportedAt
                  assignToId
                  issueTypeId
                  priority
                  reportedByType
                  reportedById
                  reportedByName
                  reportedByPhone
                  reportedByEmail
                  blenderId
                  boardId
                  scheduleStartDate
                  scheduleEndDate
                  travelingStartTime
                  travelingEndTime
                  workStartTime
                  isFilterReplaced 
                  isSanitizerReplaced
                  oldMachineShiftToLocationId
                  convertToLabTicket
                  assignedNewMachineId
                  assignedNewMachine {
                    id
                    name
                  }
                  oldMachineShiftToLocation {
                    id
                    name
                  }
                  board {
                    title
                    id
                  }
                  blender {
                    title
                    id
                  }
                  replaceNewTubeDoors1mmShorter
                  reportedByUser {
                    firstName
                    lastName
                  }
                  issueType {
                    id
                    name
                  }
                  serviceType
                  issuesReported {
                    id
                    name
                  }
                  machineServices {
                    id
                    name
                  }
                  operations {
                    id
                    name
                  }
                  diagnosisDone {
                    id
                    name
                  }
                  machineServicesDone {
                    id
                    name
                  }
                  operationsDone {
                    id
                    name
                  }
                  marketingOrOthers {
                    id
                    name
                  }
                  marketingMaterials {
                    id
                    name
                  }
                  diagnosisOtherInput
                  comment
                  chatDescription
                  lastStatusComment
                  lastAssigneToComment
                  status
                  howTicketClosed
                  closingDateAndTime
                  timeSpentOnTask
                  travelTime
                  customerSatisfaction
                  cleanliness
                  trafficRate
                  staffEnthusiasm
                  createdById
                  createdAt
                  updatedById
                  updatedAt
                  media{
                    url
                    type
                  }
                  signatureName
                  signatureImage {
                    url
                    type
                  }
                  machine {
                    id
                    uuid
                    serialNumber
                    name
                    locationId
                    location{
                    id
                    name
                      latitude
                      longitude
                    }
                  }
                  ticketSource {
                    id
                    name
                  }
                  assignTo {
                    id
                    firstName
                    lastName
                  }
                  createdBy {
                    id
                    firstName
                    lastName
                  }
                  updatedBy {
                    id
                    firstName
                    lastName
                  }
                  history{
                    action
                    difference
                    createdAt
                  }
                  subTasks {
                    id
                    uuid
                    ticketType
                    machineId
                    parentId
                    ticketSourceId
                    issueReportedOtherInput
                    machineServiceOtherInput
                    operationOtherInput
                    marketingOtherInput
                    reportedAt
                    assignToId
                    issueTypeId
                    priority
                    issueType {
                      id
                      name
                    }
                    serviceType
                    machineServices {
                      id
                      name
                    }
                    operations {
                      id
                      name
                    }
                    marketingOrOthers {
                      id
                      name
                    }
                    machineServicesDone {
                      id
                      name
                    }
                    operationsDone {
                      id
                      name
                    }
                    comment
                    lastStatusComment
                    lastAssigneToComment
                    status
                    howTicketClosed
                    closingDateAndTime
                    timeSpentOnTask
                    travelTime
                    customerSatisfaction
                    cleanliness
                    trafficRate
                    staffEnthusiasm
                    oldMachineShiftToLocationId
                    convertToLabTicket
                    oldMachineShiftToLocation {
                      id
                      name
                    }
                    createdById
                    createdAt
                    updatedById
                    updatedAt
                    media{
                      url
                      type
                    }
                    machine {
                      id
                      uuid
                      serialNumber
                      name
                      locationId
                    }
                    ticketSource {
                      id
                      name
                    }
                    assignTo {
                      id
                      firstName
                      lastName
                    }
                    createdBy {
                      id
                      firstName
                      lastName
                    }
                    updatedBy {
                      id
                      firstName
                      lastName
                    }
                  }
                }
            }
            `,
      variables: { id },
    },
  });
  return data?.data?.data?.getTicket;
}

export async function getTicketByIdForCreateSubTask(id: string) {
  const data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
            query($id: String!) {
                getTicket(id: $id) {
                  id
                  uuid
                  }
            }
            `,
      variables: { id },
    },
  });
  return data?.data?.data?.getTicket;
}

export async function getTicketByIdForStatusChange(id: string) {
  const data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
            query($id: String!) {
                getTicket(id: $id) {
                  id
                  uuid
                  ticketType
                  machineId
                  machineServiceOtherInput
                  operationOtherInput
                  marketingOtherInput
                  blenderId
                  boardId
                  isFilterReplaced 
                  isSanitizerReplaced
                  oldMachineShiftToLocationId
                  convertToLabTicket
                  assignedNewMachine {
                    id
                    name
                  }
                  oldMachineShiftToLocation {
                    id
                    name
                  }
                  board {
                    title
                    id
                  }
                  blender {
                    title
                    id
                  }
                  replaceNewTubeDoors1mmShorter
                  diagnosisDone {
                    id
                    name
                  }
                  machineServicesDone {
                    id
                    name
                  }
                  operationsDone {
                    id
                    name
                  }
                  marketingOrOthers {
                    id
                    name
                  }
                  marketingMaterials {
                    id
                    name
                  }
                  diagnosisOtherInput
                  comment
                  chatDescription
                  lastStatusComment
                  status
                  howTicketClosed
                  timeSpentOnTask
                  travelTime
                  customerSatisfaction
                  cleanliness
                  trafficRate
                  staffEnthusiasm
                  machine {
                    id
                    uuid
                    serialNumber
                    name
                    locationId
                    location{
                      name
                    }
                  }
                }
            }
            `,
      variables: { id },
    },
  });
  return data?.data?.data?.getTicket;
}

export interface GetMachineServiceType {
  id: string;
  name: string;
}
export async function getMachineService(): Promise<GetMachineServiceType[]> {
  const data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
            query{
                getMachineService {
                  id
                  name
                }
              }
            `,
      variables: {},
    },
  });
  return data?.data?.data?.getMachineService;
}

export interface GetIssueReportedType {
  id: string;
  name: string;
}
export async function getIssueReported() : Promise<GetIssueReportedType[]> {
  const data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
            query{
              getIssueReported {
                id
                name
              }
              }
            `,
      variables: {},
    },
  });
  return data?.data?.data?.getIssueReported;
}

export interface GetMarketingType {
  id: string;
  name: string;  
}

export async function getMarketing(): Promise<GetMarketingType[]> {
  const data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
              query{
                getMarketing {
                  id
                  name
                }
              }
              `,
      variables: {},
    },
  });
  return data?.data?.data?.getMarketing;
}

export interface GetOperationType {
  id: string;
  name: string;  
}

export async function getOperations():Promise<GetOperationType[]> {
  const data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
                query{
                  getOperations {
                    id
                    name
                  }
                }
                `,
      variables: {},
    },
  });
  return data?.data?.data?.getOperations;
}

export interface GetTicketSourcesType {
  id: string;
  name: string;  
}

export async function getTicketSources(): Promise<GetTicketSourcesType[]> {
  const data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
                  query {
                    getTicketSources {
                      id
                      name
                    }
                  }
                  `,
      variables: {},
    },
  });
  return data?.data?.data?.getTicketSources;
}


interface UpdateTicketInput {
  id: string;
  ticketType?: string;
  machineId?: string;
  ticketSourceId?: string;
  reportedAt?: string;
  assignToId?: string;
  priority?: string;
  serviceType?: string;
  comment?: string;
  chatDescription?: string;
  machineServices?: string[];
  marketingMaterials?: string[];
  marketingOrOthers?: string[];
  operations?: string[];
  howTicketClosed?: string | null;
  closingDateAndTime?: string;
  isClosed?: boolean;
  timeSpentOnTask?: number;
  travelTime?: number;
  customerSatisfaction?: string | null;
  cleanliness?: string | null;
  trafficRate?: string | null;
  staffEnthusiasm?: string | null;
  media?: string[];
  machineServiceOtherInput?: string;
  operationOtherInput?: string;
  marketingOtherInput?: string;
  issueReportedOtherInput?: string;
  issuesReported?: string[];
}

export async function updateTicket(input: UpdateTicketInput) {
  let data;
  data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
        mutation updateTicket (
          $input: UpdateTicketInput!
        ){
          updateTicket(
            updateTicketInput: $input
            )
        }
        `,
      variables: {
        input,
      },
    },
  }).catch((e: any) => (data = e.response));

  return data;
}